
import { Component, Vue, Watch } from 'vue-property-decorator';
import OsReportForm from '@/components/shared/reports/OsReportForm.vue';
import { IReport } from '@/models/application/IReport';
import { reportContentCategoriesApi, reportsApi } from '@/apis';
import { AppDirtyUtil } from '@/utils/AppDirtyUtil';
import OsSheet from '@/components/core/sheet/OsSheet.vue';
import OsLoadingIndicator from '@/components/core/OsLoadingIndicator.vue';
import { IReportContent } from '@/models/application/IReportContent';
import OsReportContentEditor from '@/components/shared/reports/OsReportContentEditor.vue';
import {
  FormOfAddress,
  Gender,
  IReportContentCategory,
  ReportType
} from '@/models/application';
import OsCard from '@/components/core/card/OsCard.vue';
import OsToolbar from '@/components/core/OsToolbar.vue';
import OsCloseButton from '@/components/core/OsCloseButton.vue';

@Component({
  computed: {
    ReportType() {
      return ReportType;
    }
  },
  components: {
    OsCloseButton,
    OsToolbar,
    OsCard,
    OsReportContentEditor,
    OsLoadingIndicator,
    OsSheet,
    OsReportForm
  }
})
export default class ReportsId extends Vue {
  appDirtyUtil: AppDirtyUtil = new AppDirtyUtil();
  report: IReport | null = null;
  contents: IReportContent[] = [];
  contentCategories: IReportContentCategory[] = [];

  loading = false;
  reportId!: string;

  previewContentAsBase64: string | null = null;
  previewShowDialog = false;
  previewContent: IReportContent | null = null;

  @Watch('contents', { deep: true })
  onContentsChanged() {
    setTimeout(() => {
      this.appDirtyUtil.update(this.contents);
    }, 1);
  }

  created() {
    this.reportId = this.$route.params.id;
  }

  async mounted() {
    this.report = await reportsApi.getReportById(this.reportId);
    this.contents = await reportsApi.getReportContentByReportId(this.reportId);
    this.contentCategories =
      await reportContentCategoriesApi.getReportContentCategories();

    this.appDirtyUtil.init(this.contents);
  }

  async onSave() {
    this.loading = true;
    const originalContents =
      this.appDirtyUtil.getOriginalObject() as IReportContent[];

    try {
      for (let i = 0; i < this.contents.length; i++) {
        const c = this.contents[i];
        const cOriginal = originalContents.find((o) => o.id === c.id);

        if (c.content === cOriginal?.content) {
          continue;
        }

        const updateResult = await reportsApi.updateReportContent(
          this.reportId,
          c
        );
        this.contents[i].content = updateResult.content;
      }

      this.appDirtyUtil.init(this.contents);
    } finally {
      this.loading = false;
    }
  }

  async onOpenPreview(event: {
    content: IReportContent;
    type: ReportType;
    gender: Gender;
    formOfAddress: FormOfAddress;
  }) {
    try {
      this.loading = true;

      let base64Content = '';

      if (event.type === ReportType.Actual) {
        base64Content = await reportsApi.getActualProfileContentPreview(
          event.content,
          event.gender,
          event.formOfAddress
        );
      } else if (event.type === ReportType.Target) {
        base64Content = await reportsApi.getTargetProfileContentPreview(
          event.content
        );
      }

      if (!base64Content) {
        return;
      }

      this.previewContent = event.content;
      this.previewContentAsBase64 = `data:application/pdf;base64,${base64Content}`;
      this.previewShowDialog = true;
    } finally {
      this.loading = false;
    }
  }

  undoClicked() {
    this.contents = this.appDirtyUtil.getOriginalObject();
    this.appDirtyUtil.init(this.contents);
  }
}
